import assign from "lodash/fp/assign";
import apis from "../../core/apis.js";

class CompanyResource {
  constructor($resource, Upload) {
    "ngInject";

    this.$resource = $resource;
    this.Upload = Upload;
  }

  search(query = "", params) {
    return this.$resource(apis.company + "autocomplete/").get(
      assign(params, { query })
    );
  }

  get(id) {
    return this.$resource(apis.company + id).get();
  }

  getPaymentMethods(id, params) {
    return this.$resource(apis.company + id + "/payment_methods").query(params);
  }

  updatePaymentMethods(id, item) {
    return this.$resource(apis.company + id + "/payment_methods", null, {
      update: { method: "PATCH", isArray: true },
    }).update(item);
  }

  getAll(param) {
    return this.$resource(apis.company).get(param);
  }

  post(item) {
    return this.$resource(apis.company).save(item);
  }

  update(id, item) {
    return this.$resource(apis.company + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }

  uploadDocument(data, companyResourceId) {
    const url = apis.company + companyResourceId + "/upload_document";
    const request = this.Upload.upload({
      method: "POST",
      url,
      data,
    });
    return { $promise: request };
  }

  updateDocument(data, companyResourceId) {
    return this.$resource(apis.company + companyResourceId, null, {
      update: { method: "PATCH" },
    }).update(data);
  }

  getCaptains(params) {
    return this.$resource(apis.captain).get(params);
  }

  getBuses(params) {
    return this.$resource(apis.bus).get(params);
  }

  addManagers(id, managers) {
    return this.$resource(apis.company + id + "/managers", null, {
      update: { method: "PUT" },
    }).update(managers);
  }

  deleteManagers(id, managers) {
    return this.$resource(apis.company + id + "/managers", null, {
      delete: { method: "DELETE", data: managers },
    }).delete();
  }
}

export default CompanyResource;



// WEBPACK FOOTER //
// ./src/resources/company/company.resource.js